/*
 * The english translation of the cooking pot view & the postOnBoardingStore (Tour)
 */
export const COOKING_POT_VIEW_EN = {
  skipTour: 'Skip Tour',
  previousTourStep: 'Previous',
  next: 'Next',
  finish: 'Finish',
  continueAfterAction: 'Continue',
  //postOnoardingStore.ts
  GeneratedInputComponentHeader: '👋 Welcome to newsrooms.ai!',
  GeneratedInputComponentDescription:
    'Your AI-powered content creation studio. Well guide you through our workspace designed for journalists, PR specialists, marketers, and content creators.',
  GeneratedInputComponentHint:
    'Press next to discover your personalized content creation environment.',

  LeftPanelHeader: 'Input Resources Panel',
  LeftPanelDescription:
    'This panel contains all your input tools - from live news feeds to file uploads, audio transcription, and research tools. Everything you need to gather source material.',
  LeftPanelHint:
    'Each tool can be expanded and collapsed as you work. Try clicking on one during your workflow.',

  Panel3Header: 'Content Database Feed',
  Panel3Description:
    'Access real-time news and trending content from our content database to incorporate into your writing. Ideal for journalists and editors who need to stay current with breaking stories and industry updates.',
  Panel3Hint:
    'Click to expand and see the latest content from selected sources. Great for PR managers and journalists.',

  Panel11Header: 'Multi-Format Upload',
  Panel11Description:
    'Import documents, PDFs, audio files, and more to extract content for repurposing. Perfect for when you need to transform existing materials into new formats.',
  Panel11Hint:
    'Try clicking to upload files from your computer or paste URLs for automatic content extraction.',

  ResizablePanelGroupHeader: 'The Cooking Pot',
  ResizablePanelGroupDescription:
    'This is your main workspace - your "cooking pot" for content creation. Input on the left transforms into your professional output on the right, styled to your brand voice and audience preferences.',
  ResizablePanelGroupHint:
    'Adjust the divider to give more space to either your input or generated content as needed.',

  RightPanelHeader: 'Content Configuration',
  RightPanelDescription:
    'This panel contains your generation controls and preferences. Define your target audience, platforms, brand voice, and communication tasks to customize content precisely.',
  RightPanelHint:
    'Your professionally tailored settings influence how AI transforms your inputs into polished content.',

  Panel1Header: 'Generate Button',
  Panel1Description:
    'The heart of newsrooms.ai! Click here to transform your input into professional content tailored to your selected language, voice preferences, and content types.',
  Panel1Hint:
    'Once youve added your input text and configured your preferences, this button brings everything together.',

  Panel16Header: 'Communication Task',
  Panel16Description:
    'Select your primary content format - whether you need blog posts, press releases, case studies, video scripts, or email newsletters. This determines the structure and style of your generated content.',
  Panel16Hint:
    'Click to see different content types including articles, white papers, landing page copy, and more specialized formats.',

  Panel12Header: 'Clear Workspace',
  Panel12Description:
    'Start fresh with a new project. This resets your workspace, allowing you to begin a new content creation task without previous inputs affecting your results.',
  Panel12Hint: 'Use this when moving between different projects or communication tasks.',

  Panel6Header: 'Advanced Settings',
  Panel6Description:
    'Fine-tune your experience with advanced controls. Adjust language settings, toggle between professional styles like Journalist, PR Manager, or Editor-in-Chief, and customize tone preferences.',
  Panel6Hint: 'Explore these settings to tailor the system perfectly to your professional needs.',

  CaptionsHeader: 'Additional Content Types',
  CaptionsDescription:
    'After generating your main content, this area displays additional outputs like Twitter/X posts, email newsletter versions, and platform-specific variations customized to your selected audiences.',
  CaptionsHint:
    'These ready-to-use formats save time by automatically adapting your content for different channels and communication contexts.',
  // GeneratedInputPanel.vue
  titlePlaceholder: 'Enter your title here..',
  // CopyToClipboard.ts
  copiedToClipboard: 'Copied to clipboard',
  failedToCopy: 'Failed to copy',
  noInputText: 'No input text provided',
  inputTextTooShort: 'Input text must have at least 50 words',
  canceledGeneration: 'Generation canceled',
  generating: 'Generating',
  generationCompleted: 'Generation completed!',
  accountCannotPublish: 'Your account can not publish',
  changeInputOrPreferences: 'Change input/preferences to regenerate!',
  characters: 'characters',
  // AI GENERATED
  generationFailed: 'Generation failed. Please try again.',
  // AI GENERATED
  errorGeneratingTitles: 'Could not generate titles.',
  // AI GENERATED
  headlinePromptNotFound: 'Headline prompt template not found.',
  // AI GENERATED
  socialMediaPromptNotFound: 'Social media prompt template not found.'
}
/*
 * The german translation of the cooking pot view & the postOnBoardingStore (Tour)
 */
export const COOKING_POT_VIEW_DE = {
  skipTour: 'Überspringen',
  previousTourStep: 'Zurück',
  next: 'Weiter',
  finish: 'Beenden',
  continueAfterAction: 'Fortfahren',
  //postOnoardingStore.ts
  GeneratedInputComponentHeader: '👋 Willkommen bei newsrooms.ai!',
  GeneratedInputComponentDescription:
    'Ihr KI-gestütztes Content-Creation-Studio. Wir führen Sie durch unseren Arbeitsbereich, der für Journalisten, PR-Spezialisten, Vermarkter und Content-Ersteller entwickelt wurde.',
  GeneratedInputComponentHint:
    'Drücken Sie "Weiter", um Ihre personalisierte Content-Creation-Umgebung zu entdecken.',

  LeftPanelHeader: 'Eingabe-Ressourcen-Panel',
  LeftPanelDescription:
    'Dieses Panel enthält alle Ihre Eingabe-Tools - von Live-Nachrichten-Feeds bis zu Datei-Uploads, Audio-Transkription und Recherchetools. Alles, was Sie brauchen, um Quellmaterial zu sammeln.',
  LeftPanelHint:
    'Jedes Tool kann während Ihrer Arbeit erweitert und minimiert werden. Versuchen Sie, während Ihres Workflows auf eines zu klicken.',

  Panel3Header: 'Content-Datenbank-Feed',
  Panel3Description:
    'Greifen Sie auf Echtzeit-Nachrichten und trendige Inhalte aus unserer Content-Datenbank zu, um sie in Ihre Texte einzubauen. Ideal für Journalisten und Redakteure, die über aktuelle Geschichten und Branchenaktualisierungen auf dem Laufenden bleiben müssen.',
  Panel3Hint:
    'Klicken Sie, um zu erweitern und die neuesten Inhalte aus ausgewählten Quellen zu sehen. Großartig für PR-Manager und Journalisten.',

  Panel11Header: 'Multi-Format-Upload',
  Panel11Description:
    'Importieren Sie Dokumente, PDFs, Audiodateien und mehr, um Inhalte zur Wiederverwendung zu extrahieren. Perfekt, wenn Sie vorhandenes Material in neue Formate umwandeln müssen.',
  Panel11Hint:
    'Versuchen Sie, Dateien von Ihrem Computer hochzuladen oder URLs für die automatische Inhaltsextraktion einzufügen.',

  ResizablePanelGroupHeader: 'Der Kochtopf',
  ResizablePanelGroupDescription:
    'Dies ist Ihr Hauptarbeitsbereich - Ihr "Kochtopf" für die Content-Erstellung. Die Eingabe links verwandelt sich in Ihre professionelle Ausgabe rechts, an Ihre Markensprache und Zielgruppenpräferenzen angepasst.',
  ResizablePanelGroupHint:
    'Passen Sie den Teiler an, um entweder Ihrer Eingabe oder dem generierten Inhalt mehr Platz zu geben.',

  RightPanelHeader: 'Inhaltskonfiguration',
  RightPanelDescription:
    'Dieses Panel enthält Ihre Generierungskontrollen und Präferenzen. Definieren Sie Ihre Zielgruppe, Plattformen, Markensprache und Kommunikationsaufgaben, um Inhalte präzise anzupassen.',
  RightPanelHint:
    'Ihre professionell maßgeschneiderten Einstellungen beeinflussen, wie KI Ihre Eingaben in polierte Inhalte umwandelt.',

  Panel1Header: 'Generieren-Schaltfläche',
  Panel1Description:
    'Das Herzstück von newsrooms.ai! Klicken Sie hier, um Ihre Eingabe in professionelle Inhalte umzuwandeln, die auf Ihre ausgewählte Sprache, Stimmpräferenzen und Inhaltstypen zugeschnitten sind.',
  Panel1Hint:
    'Sobald Sie Ihren Eingabetext hinzugefügt und Ihre Präferenzen konfiguriert haben, bringt diese Schaltfläche alles zusammen.',

  Panel16Header: 'Kommunikationsaufgabe',
  Panel16Description:
    'Wählen Sie Ihr primäres Content-Format - ob Sie Blogbeiträge, Pressetexte, Fallstudien, Videoskripte oder E-Mail-Newsletter benötigen. Dies bestimmt die Struktur und den Stil Ihres generierten Inhalts.',
  Panel16Hint:
    'Klicken Sie, um verschiedene Inhaltstypen zu sehen, darunter Artikel, Whitepaper, Landing-Page-Texte und weitere spezialisierte Formate.',

  Panel12Header: 'Arbeitsbereich leeren',
  Panel12Description:
    'Starten Sie frisch mit einem neuen Projekt. Dies setzt Ihren Arbeitsbereich zurück und ermöglicht es Ihnen, eine neue Content-Erstellungsaufgabe zu beginnen, ohne dass vorherige Eingaben Ihre Ergebnisse beeinflussen.',
  Panel12Hint:
    'Verwenden Sie dies, wenn Sie zwischen verschiedenen Projekten oder Kommunikationsaufgaben wechseln.',

  Panel6Header: 'Erweiterte Einstellungen',
  Panel6Description:
    'Verfeinern Sie Ihre Erfahrung mit erweiterten Steuerungen. Passen Sie Spracheinstellungen an, wechseln Sie zwischen professionellen Stilen wie Journalist, PR-Manager oder Chefredakteur und passen Sie Tonpräferenzen an.',
  Panel6Hint:
    'Erkunden Sie diese Einstellungen, um das System perfekt auf Ihre beruflichen Bedürfnisse zuzuschneiden.',

  CaptionsHeader: 'Zusätzliche Inhaltstypen',
  CaptionsDescription:
    'Nach der Generierung Ihres Hauptinhalts zeigt dieser Bereich zusätzliche Ausgaben wie Twitter/X-Beiträge, E-Mail-Newsletter-Versionen und plattformspezifische Variationen an, die auf Ihre ausgewählten Zielgruppen zugeschnitten sind.',
  CaptionsHint:
    'Diese gebrauchsfertigen Formate sparen Zeit, indem sie Ihre Inhalte automatisch für verschiedene Kanäle und Kommunikationskontexte anpassen.',
  // GeneratedInputPanel.vue
  titlePlaceholder: 'Titel hier eingeben...',
  // CopyToClipboard.ts
  copiedToClipboard: 'In Zwischenablage kopiert',
  failedToCopy: 'Kopieren fehlgeschlagen',
  noInputText: 'Kein Eingabetext bereitgestellt',
  inputTextTooShort: 'Eingabetext muss mindestens 50 Wörter enthalten',
  canceledGeneration: 'Generierung abgebrochen',
  generating: 'Generiere',
  generationCompleted: 'Generierung abgeschlossen!',
  accountCannotPublish: 'Ihr Konto kann nicht veröffentlichen',
  changeInputOrPreferences: 'Eingabe/Einstellungen ändern, um neu zu generieren!',
  characters: 'Zeichen',
  // AI GENERATED
  generationFailed: 'Generierung fehlgeschlagen. Bitte erneut versuchen.',
  // AI GENERATED
  errorGeneratingTitles: 'Titel konnten nicht generiert werden.',
  // AI GENERATED
  headlinePromptNotFound: 'Vorlage für die Überschriften nicht gefunden.',
  // AI GENERATED
  socialMediaPromptNotFound: 'Vorlage für Social-Media-Texte nicht gefunden.'
}
